import type { TypeWindowKey } from '@/function/calendar/calendar.window';
import windowDays from '@/function/calendar/calendar.window.days';
import { dashboardApi } from '@/store/api/base/api.base';
import type { TypeRecurringCalendarWindow } from '@/types/recurring/types.recurring.calendar';

export const RECURRING_CALENDAR_TAG = 'RecurringCalendar' as const;

const KEEP_FOR = 300;

export const recurringCalendarApi = dashboardApi.enhanceEndpoints({ addTagTypes: [RECURRING_CALENDAR_TAG] }).injectEndpoints({
    endpoints: (build) => ({
        listRecurringCalendarWindow: build.query<TypeRecurringCalendarWindow, TypeWindowKey>({
            query: (key) => ({ url: '/recurrings/calendar', params: windowDays(key) }),
            transformResponse: (response: TypeRecurringCalendarWindow | null) => ({ items: response?.items ?? [], truncated: Boolean(response?.truncated) }),
            providesTags: [RECURRING_CALENDAR_TAG],
            keepUnusedDataFor: KEEP_FOR,
        }),
    }),
});

export const { useListRecurringCalendarWindowQuery } = recurringCalendarApi;

export default recurringCalendarApi;
